import Main from './Main'
import Lista from './components/Edital'
import Novo from './components/NovoEdital'

export default [
  {
    // TODO: VER PQ NÃO ESTÃO APARECENDO NA ROTA O NOME
    path: 'edital',
    name: 'edital',
    component: Main,
    redirect: { name: 'edital.list' },
    children: [
      {
        path: '/',
        name: 'edital.list',
        component: Lista
      },
      {
        path: 'registro',
        name: 'edital.novo',
        component: Novo
      },
      {
        path: ':id',
        name: 'edital.edit',
        component: Novo
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/app/website/edital/routes.js